import { Suspense, lazy } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/sendSms/main"));

const SendSmS = () => {
    return (
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default SendSmS;